import { useEffect, useState } from "react";
import { Loader2, BellRing } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Input } from "../ui/input";
import { api, apiError } from "../../lib/api";

export const WaitlistDialog = ({ trip, onClose }) => {
  const [f, setF] = useState({ name: "", email: "", phone: "" });
  const [cat, setCat] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => { setDone(null); setError(""); setCat(trip?.category ?? ""); }, [trip]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const { data } = await api.post("/waitlist", { trip_id: trip.id, from_idx: trip.from_idx, to_idx: trip.to_idx, category: cat || trip.category, passengers: Number(trip.passengers) || 1, ...f });
      setDone(data);
    } catch (err) { setError(apiError(err)); } finally { setLoading(false); }
  };

  return (
    <Dialog open={Boolean(trip)} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="waitlist-dialog" className="max-w-md rounded-3xl" data-lenis-prevent>
        <DialogHeader>
          <DialogTitle className="font-display text-3xl">Lista de espera</DialogTitle>
          <DialogDescription>{trip && `${trip.origin} → ${trip.destination} · ${trip.date} · ${trip.departure} hs · ${trip.service} · ${trip.passengers} pasajero(s)`}</DialogDescription>
        </DialogHeader>
        {Number(trip?.passengers) > 6 ? (
          <p data-testid="waitlist-too-many" className="rounded-2xl bg-[var(--paper)] p-4 text-sm">Para grupos de más de 6 pasajeros, consultanos por WhatsApp o en boletería.</p>
        ) : done ? (
          <div data-testid="waitlist-success" className="py-2 text-center">
            <BellRing className="mx-auto h-12 w-12 text-[var(--forest)]" />
            <p className="mt-3 font-display text-2xl">¡Te anotamos!</p>
            <p className="mt-2 text-sm text-[var(--muted-ink)]">Sos el número <b>{done.position}</b> de la lista. Si se libera lugar te avisamos por email a <b>{f.email}</b>: el primero que reserva se queda con la butaca.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            {trip?.categories?.length > 1 && (
              <select data-testid="waitlist-category" value={cat} onChange={(e) => setCat(e.target.value)} className="h-12 w-full rounded-xl border border-black/10 bg-white px-3">
                {trip.categories.map((c) => <option key={c.category} value={c.category}>{c.category} · {c.free} libre(s)</option>)}
              </select>
            )}
            <Input data-testid="waitlist-name" placeholder="Nombre y apellido" value={f.name} onChange={set("name")} required minLength={2} className="h-12 rounded-xl" />
            <Input data-testid="waitlist-email" type="email" placeholder="Email" value={f.email} onChange={set("email")} required className="h-12 rounded-xl" />
            <Input data-testid="waitlist-phone" placeholder="Teléfono (opcional)" value={f.phone} onChange={set("phone")} className="h-12 rounded-xl" />
            {error && <p data-testid="waitlist-error" className="text-sm font-medium text-red-700">{error}</p>}
            <button data-testid="waitlist-submit" disabled={loading} className="flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-[var(--forest)] font-bold text-white">{loading && <Loader2 className="h-4 w-4 animate-spin" />} Avisarme si se libera lugar</button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
